import React, { createContext, useReducer } from 'react';
export const MutationStateContext = createContext('');
export const MutationStateDispatchContext = createContext(() => { });
function reducer(state, action) {
    switch (action.type) {
        case 'LOADING':
            return 'loading';
        case 'FINISHED':
            return 'finished';
        default:
            return '';
    }
}
function MutationStateProvider({ children }) {
    const [state, dispatch] = useReducer(reducer, '');
    return (React.createElement(MutationStateDispatchContext.Provider, { value: dispatch },
        React.createElement(MutationStateContext.Provider, { value: state }, children)));
}
export default MutationStateProvider;
